<template>
  <div class="card">
    <!-- <img :src="image" :alt="title" class="card-image" /> -->
    <h3 class="card-title">{{ title }}</h3>
    <p class="card-description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: "CardComponent",
  props: {
    // image: {
    //   type: String,
    //   required: true,
    // },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
@import "@/styles/components/Card.scss";
</style>
